"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"

export function ScrollToTop() {
  const pathname = usePathname()

  useEffect(() => {
    // Scroll to top on route change
    // "instant" is valid per CSSOM View and supported by browsers, but this
    // TypeScript version's DOM lib only lists "auto" | "smooth".
    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior })
  }, [pathname])

  return null
}
